module.exports = __webpack_public_path__ + "media/images/trash-174b2e82b33f9a559428ecf174d317c2.svg";